module.exports = __webpack_public_path__ + "static/media/Med.96737968.jpg";